export const CLOSE_BAR = 'INFO_BAR_TYPE__CLOSE_BAR'